import { setLinkedToAbha } from './../../actions/claimDetailsAction';
import moment from 'moment';
import { put, select, takeLatest } from 'redux-saga/effects';
import { RootState } from '../..';
import { getDocumentList } from '../../../modules/abdmHIU/abdmUtils';
import {ABDM_HIP_REGISTER_COMMON_ERR, COMMON_ERROR, GENERATE_OTP_ERR,
  LINK_CONTEXT_FETCH_MODES_COMMON_ERR, OTP_VERIFICATION_ERR } from '../../../shared/constants/commonConstants';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import SendRequest from '../../../shared/services/sendRequest.service';
import { centeredNotification } from '../../../utils/utility';
import { ApplicationDetailModel } from '../../models/applicationDetailModel';
import { LinkContextModel } from '../../models/linkContextModel';
import actionTypes from '../../types/linkContextTypes';
import { ABDMHiuState } from '../../models/abdmHIUModel';
import { formatSelectedFilter } from '../../../modules/crm/inPatient/service/crmUtils';
import { updateAuthFetchError } from '../../actions/linkContextAction';
let referenceKeyConfirm = '';

function* getClaimDocumentsForABHA({ payload: { onSuccess, onError } }: any): Generator {
  const url = GLOBAL_URL.CRM_BASE_URL + 'api/HealthLocker/UploadM2Doc';
  try {
    const { abhaFormData, documentList }: any = yield select((state: RootState): LinkContextModel => state?.linkContext || {});
    const { hospActionId, providerId, doa, inPatientNo, payerId: payerName, payerClaimNo, procedure }: any =
      yield select((state: RootState): any => state?.admissionDetails?.claimDetails);
    const appDetail = ApplicationDetail.instance;
    const finalPayerClaimNo = payerClaimNo || '';
    const finalProcedure = procedure ? ' - ' + procedure : '';
    const {
      payerList: { payer: { uniqueIdentifier: payerId}}}: any = yield select((state: RootState): RootState => state);

    let mobileNo = ((abhaFormData?.userInfo?.patient?.identifiers || [])
      ?.find(({ type }: any): boolean => type === 'MOBILE') || {})
      ?.value || (abhaFormData?.userInfo?.patient?.mobileNo);
    mobileNo = mobileNo?.length === 10 ? `+91${mobileNo}` : mobileNo;
    const { dayOfBirth, monthOfBirth, yearOfBirth, gender, name } = abhaFormData?.userInfo?.patient || {};
    const dob = `${yearOfBirth}-${monthOfBirth}-${dayOfBirth}`;
    const reqObj = {
      dcRequest: {
      doa,
      hospActionId,
      payerId,
      documentList,
      referenceKey: referenceKeyConfirm,
      accessToken: abhaFormData?.userInfo?.accessToken,
      },
      hipAddContext: {
      providerId,
      link: {
        accessToken: abhaFormData?.userInfo?.accessToken,
        patient: {
          patientAbha: abhaFormData?.userInfo?.patient?.id || abhaFormData?.abhaNumber,
          patientId: inPatientNo ? inPatientNo : null,
          referenceNumber: abhaFormData?.referenceNumber,
          careContextDesc: payerName + ' claim ' + finalPayerClaimNo + finalProcedure,
          display: abhaFormData?.userInfo?.patient?.name,
          mobileNo,
          name,
          dob: moment(dob).format(),
          gender,
          careContexts: documentList,
        },
      },
    },
    hipId: appDetail.getHipId(),
    linkedToAbha: true,
    };
    const {isSuccess }: any = yield SendRequest.instance.post(url, reqObj);
    if (isSuccess) {
      onSuccess();
      yield put(setLinkedToAbha('True'));
    } else {
      centeredNotification('');
    }
  } catch (e) {
    centeredNotification('');
  }
}
function* getAuthModes({ payload: { onSuccess, onError } }: any): Generator {
  try {
    const url = GLOBAL_URL.CRM_BASE_URL + 'v0.5/users/auth/fetch-modes';
    const { abhaFormData = {} }: any = yield select((state: RootState): LinkContextModel => state?.linkContext || {});
    const appDetail = ApplicationDetail.instance;
    const request = {
      query: {
        id: abhaFormData?.abhaNumber,
        requester: {
          type: 'HIP',
          id: appDetail.getHipId(),
        },
      },
    };
    const { isSuccess, errorMessage, auth }: any = yield SendRequest.instance.post(url, request);
    if (isSuccess && auth) {
      onSuccess(auth);
    } else {
      yield put(updateAuthFetchError(true));
      onError(errorMessage || LINK_CONTEXT_FETCH_MODES_COMMON_ERR);
    }
  } catch (e) {
    yield put(updateAuthFetchError(true));
    onError(LINK_CONTEXT_FETCH_MODES_COMMON_ERR);
  }
}

function* generateOTP({ payload: { onSuccess, onError } }: any): Generator {
  const url = GLOBAL_URL.CRM_BASE_URL + 'v0.5/users/auth/init';
  const appDetail = ApplicationDetail.instance;
  const { abhaFormData }: any = yield select((state: RootState): LinkContextModel => state?.linkContext || {});
  try {
    const reqObj = {
      query: {
        id: abhaFormData?.abhaNumber,
        purpose: 'LINK',
        authMode: abhaFormData?.authMode,
        requester: {
          type: 'HIP',
          id: appDetail.getHipId(),
        },
      },
    };
    const { isSuccess, errorMessage, auth }: any = yield SendRequest.instance.post(url, reqObj);
    if (isSuccess) {
      onSuccess(auth);
    } else {
      onError(errorMessage || GENERATE_OTP_ERR);
    }
  } catch (e) {
    onError(GENERATE_OTP_ERR);
  }
}

function* verifyOtp({ payload: { onSuccess, onError } }: any): Generator {
  const verifyOtpUrl = GLOBAL_URL.CRM_BASE_URL + 'v0.5/users/auth/confirm';
  const { abhaFormData }: any = yield select((state: RootState): LinkContextModel => state?.linkContext || {});
  try {
    const verifyOtpRequest = {
      transactionId: abhaFormData?.transactionId,
      otp: abhaFormData?.otp ? Number(abhaFormData?.otp) : undefined,
      demographic: {
        name: abhaFormData?.userName,
        gender: abhaFormData?.userGender,
        dateOfBirth: moment(abhaFormData?.userDob).format('YYYY-MM-DD')?.toString(),
        identifier: {
          type: 'MOBILE',
          value: String(abhaFormData?.mobile)?.split(' ')?.join(''),
        },
      },
    };
    const response: any = yield SendRequest.instance.post(verifyOtpUrl, verifyOtpRequest);
    const { isSuccess, errorMessage, auth, referenceKey } = response || {};
    if (isSuccess) {
      onSuccess(auth);
      referenceKeyConfirm = referenceKey;
    } else {
      onError(errorMessage || OTP_VERIFICATION_ERR);
    }
  } catch (e) {
    onError(OTP_VERIFICATION_ERR);
  }
}

function* saveDocuments({ payload: { onSuccess, onError } }: any): Generator {
  const url = GLOBAL_URL.CRM_BASE_URL + 'v0.5/users/auth/add-contexts';
  const appDetail: any = yield select((state: RootState): ApplicationDetailModel => state?.applicationDetail);
  try {
    const { abhaFormData, fileList }: any = yield select((state: RootState): LinkContextModel => state?.linkContext || {});

    let mobileNo = ((abhaFormData?.userInfo?.patient?.identifiers || [])
      ?.find(({ type }: any): boolean => type === 'MOBILE') || {})
      ?.value;
    mobileNo = mobileNo?.length === 10 ? `+91${mobileNo}` : mobileNo;
    const { dayOfBirth, monthOfBirth, yearOfBirth, gender, name } = abhaFormData?.userInfo?.patient || {};
    const dob = `${yearOfBirth}-${monthOfBirth}-${dayOfBirth}`;
    const reqObj = {
      referenceKey: referenceKeyConfirm,
      hipId : appDetail.getHipId(),
      link: {
        accessToken: abhaFormData?.userInfo?.accessToken,
        patient: {
          patientAbha: abhaFormData?.abhaNumber,
          referenceNumber: abhaFormData?.referenceNumber,
          careContextDesc: abhaFormData?.careContextDesc,
          display: abhaFormData?.userInfo?.patient?.name,
          mobileNo,
          name,
          dob: moment(dob).format(),
          gender,
          careContexts: getDocumentList(fileList),
        },
      },
    };
    const { errorMessage, isSuccess }: any = yield SendRequest.instance.post(url, reqObj);
    if (isSuccess) {
      onSuccess();
    } else {
      onError(errorMessage || COMMON_ERROR);
    }
  } catch (e) {
    onError(COMMON_ERROR);
  }
}

function* saveDocsWithoutAbha({ payload: { callback } }: any): Generator {
  const url = `${GLOBAL_URL.CRM_BASE_URL}api/HIP/add-contexts-withoutAbha`;
  try {
    const { abhaFormData, fileList }: any = yield select((state: RootState): LinkContextModel => state?.linkContext || {});
    const finalDto = {
      link: {
        accessToken: undefined,
        patient: {
          patientAbha: null,
          referenceNumber: abhaFormData?.referenceNumber,
          careContextDesc: abhaFormData?.careContextDesc,
          display: abhaFormData?.deeplinkName,
          mobileNo: String(abhaFormData?.deeplinkMobileNo)?.split(' ').join(''),
          name: abhaFormData?.deeplinkName,
          dob: abhaFormData?.deeplinkDOB,
          gender: abhaFormData?.deeplinkGender,
          careContexts: getDocumentList(fileList),
        },
      },
    };
    const { errorMessage, isSuccess }: any = yield SendRequest.instance.post(url, finalDto);
    if (isSuccess) {
      callback(true);
    } else {
      callback(errorMessage);
    }
  } catch (e) {
    callback(COMMON_ERROR);
  }
}

function* fetchLinkedRecords({ payload: { callBack } }: any): Generator {
  const url = GLOBAL_URL.CRM_BASE_URL + 'PatientContextList';
  const appDetail: any = yield select((state: RootState): ApplicationDetailModel => state?.applicationDetail);
  const selectedFilters: any = yield select((state: RootState): ABDMHiuState => state?.abdmHiu?.searchFilters);
  const filterKey = formatSelectedFilter(selectedFilters);
  let request: any = {
    hipId : appDetail.getHipId(),

  };
  if (filterKey.length > 0) {
    request = {
      ...request,
      filters: filterKey,
    };
  } else {
    request = {
      ...request,
        filters: [],
      };
    }
  try {
    const response = yield SendRequest.instance.post(url, request);
    const { isSuccess, errorMessage, patientContextList }: any = response || {};
    if (isSuccess) {
      callBack(patientContextList);
    } else {
      centeredNotification(errorMessage || 'Records not found');
      callBack([]);
    }
  } catch (e) {
    centeredNotification('Records not found');
    callBack([]);
  }
}

function* updateLinkedRecords({payload: { data, onSuccess, onError }}: any): Generator {
  const url = GLOBAL_URL.CRM_BASE_URL + 'v0.5/links/context/notify';
  try {
    const { isSuccess, errorMessage }: any = yield SendRequest.instance.post(url, data);
    if (isSuccess) {
      onSuccess();
    } else {
      onError(errorMessage || ABDM_HIP_REGISTER_COMMON_ERR);
    }
  } catch (e) {
    onError(ABDM_HIP_REGISTER_COMMON_ERR);
  }
}

function* fetchClaimHealthRecords({ payload: { data, onSuccess, onError } }: any): Generator {
  const baseUrl = GLOBAL_URL.CRM_BASE_URL + 'PatientContextDetail';
  const isVersioningPostAPIEnabled = ApplicationDetail?.instance?.getIsVersioningPostAPIEnabled();
  // Define the URLs for GET and POST calls
  const getUrl = baseUrl + `?HospActionId=`; // GET URL
  const postUrl = baseUrl; // POST URL (no query params for POST)

  try {
    let response: any;
    if (isVersioningPostAPIEnabled) {
      // Make the POST request if IsVersioningGetAPIEnabled is true
      response = yield SendRequest.instance.post(postUrl, data);
    } else {
      // Make the GET request if IsVersioningGetAPIEnabled is false
      response = yield SendRequest.instance.get(getUrl);
    }
    const { isSuccess, errorMessage, patientContextDTO }: any = response;
    if (isSuccess) {
      onSuccess(patientContextDTO);
    } else {
      onError(errorMessage);
    }
  } catch (e) {
    onError(COMMON_ERROR);
  }
}

export default function* watchAbdmLinkContext(): any {
  yield takeLatest(actionTypes.GET_AUTH_MODES, getAuthModes);
  yield takeLatest(actionTypes.GENERATE_OTP, generateOTP);
  yield takeLatest(actionTypes.VERIFY_OTP, verifyOtp);
  yield takeLatest(actionTypes.SAVE_DOCUMENTS, saveDocuments);
  yield takeLatest(actionTypes.GET_CLAIM_DOCS_FOR_ABHA, getClaimDocumentsForABHA);
  yield takeLatest(actionTypes.SAVE_DOCS_WITHOUT_ABHA, saveDocsWithoutAbha);
  yield takeLatest(actionTypes.FETCH_LINKED_RECORDS, fetchLinkedRecords);
  yield takeLatest(actionTypes.UPDATE_LINKED_RECORD, updateLinkedRecords);
  yield takeLatest(actionTypes.GET_CLAIM_HEALTH_RECORDS, fetchClaimHealthRecords);
}
